import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

const EasyResultsGraphic = () => {
  const data = useStaticQuery(graphql`
    query {
      easyResultsGraphicImage: file(relativePath: { eq: "graphics/easy-results-graphic.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Img
      fluid={data.easyResultsGraphicImage.childImageSharp.fluid}
      alt="Easy Results Graphic"
    />
  )
}

export default EasyResultsGraphic
